export default __webpack_public_path__ + "static/media/check-in-card.3738e3ed.png";